
// Compressed text
$('.compressed-text').each( function() {
  var thisCompText = $(this);
  var expandToggle = thisCompText.children('.expand-toggle');
  var expandToggleExpandedText = expandToggle.attr('data-expanded-text') || 'less';
  var expandToggleCompressedText = expandToggle.attr('data-compressed-text') || 'more';
  // Apply compressed text if content has more than one paragraph
  if (thisCompText.children('.inner').children('p').length > 1) {
    //expandToggle.show();
    expandToggle.off().click(function(e) {
      e.preventDefault();
      thisCompText.toggleClass('active');
      // Toggle button text (with delay for transition time)
      if (thisCompText.hasClass('active')) {
        setTimeout(function() {
          expandToggle.html(expandToggleExpandedText);
        },100);
      } else {
        setTimeout(function() {
          expandToggle.html(expandToggleCompressedText);
        },100);
      }
    });
  }
});
